import React from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from 'tss-react/mui'
import { Button } from '@mui/material'
import type { Theme, ButtonProps } from '@mui/material'

const useStyles = makeStyles()((theme: Theme) => ({
  marginRight: {
    marginRight: theme.spacing(1.5),
  },
}))

/**
 * NOTE: submitボタンのすぐ左側に配置するキャンセルボタン
 */
const MarginRightCancelButton: React.FC<ButtonProps> = ({ ...props }) => {
  const { t } = useTranslation()
  const { classes } = useStyles()

  return (
    <Button color="primary" className={classes.marginRight} {...props}>
      {t('キャンセル')}
    </Button>
  )
}

export default MarginRightCancelButton
